module.exports = __webpack_public_path__ + "static/media/iit.36d7942a.png";